import services from '../services/api';

const api = services.apiV1;

const CompanyRepository = {
  // { cpfCnpj, sourceId, name, tradingName, hasAccess, maskedEmail }
  async findByCnpj(cnpj) {
    const { data } = await api.get(`companies/by-cnpj/${cnpj}`);
    return data;
  },

  // A senha e conferida no servidor; resposta: { company, expiresAt }; a sessao fica no cookie HttpOnly
  async login({ cpfCnpj, sourceId, password }) {
    const { data } = await api.post('companies/login', {
      cpfCnpj,
      sourceId,
      password,
    });
    return data;
  },

  // Primeiro acesso e esqueci a senha: a API envia o link ao e-mail cadastrado
  async requestAccessLink({ cpfCnpj, sourceId }) {
    const { data } = await api.post('companies/access-link', {
      cpfCnpj,
      sourceId,
    });
    return data;
  },

  async setPassword({ token, password }) {
    const { data } = await api.post('companies/set-password', {
      token,
      password,
    });
    return data;
  },

  // Aceita { token } (link novo) ou { cpfCnpj, sourceId, password } (link do OS Digital)
  async autoLogin(payload) {
    const { data } = await api.post('companies/auto-login', payload);
    return data;
  },

  async changePassword({ currentPassword, newPassword }) {
    const { data } = await api.post('companies/change-password', {
      currentPassword,
      newPassword,
    });
    return data;
  },
};

export default CompanyRepository;
